import styled, { css } from 'styled-components';
import { monologueTokens } from '../../tokens/components/Monologue/tokens';

const spacingScale = '10px';

export const MonologueWrapper = styled.div`
  position: relative;

  margin-bottom: ${({ theme }) =>
    theme.monologueMarginBottom ? `calc(${spacingScale} * ${theme.monologueMarginBottom})` : 0};
  margin-top: ${({ theme }) => (theme.monologueMarginTop ? `calc(${spacingScale} * ${theme.monologueMarginTop})` : 0)};

  & > ::-webkit-scrollbar {
    -webkit-appearance: none;
    background-color: ${monologueTokens.ContainerBackgroundColorBaseDefault};
    width: ${monologueTokens.ScrollbarWidthBaseDefault};
  }

  & > ::-webkit-scrollbar-thumb {
    background-color: ${monologueTokens.ScrollbarColorBaseDefault};
    border: 1px solid ${monologueTokens.ContainerBackgroundColorBaseDefault};
    border-radius: calc(${monologueTokens.ScrollbarWidthBaseDefault} / 2);
  }
`;

export const MonologueBody = styled.div`
  font-size: ${monologueTokens.ContainerFontSizeBaseDefault};
  font-weight: ${monologueTokens.ContainerFontWeightBaseDefault};
  line-height: ${monologueTokens.ContainerFontLeadingBaseDefault};

  background-color: ${monologueTokens.ContainerBackgroundColorBaseDefault};
  border: ${monologueTokens.ContainerBorderSizeBaseDefault} solid ${monologueTokens.ContainerBorderColorBaseDefault};
  padding: ${monologueTokens.ContainerSpacingBody};

  ${({ theme }) =>
    theme.monologuePreserveFormatting &&
    css`
      white-space: pre-wrap;
    `}
`;

export const MonologueScroll = styled.div`
  border: ${monologueTokens.ContainerBorderSizeBaseDefault} solid ${monologueTokens.ContainerBorderColorBaseDefault};
  border-left: 0;
  overflow-y: auto;
  overflow-x: hidden;

  // Small elements that creates a perfect
  // aligned side border for the scrollbar
  ${({ theme }) =>
    theme.monologueBottom &&
    !theme.monologueTop &&
    css`
      border-bottom: 0;

      &::before {
        right: 0;
        bottom: 0;
        width: calc(${spacingScale} + 2);
        border-bottom: ${monologueTokens.ContainerBorderSizeBaseDefault} solid
          ${monologueTokens.ContainerBorderColorBaseDefault};
        content: '';
        position: absolute;
      }
    `}

  ${({ theme }) =>
    theme.monologueTop &&
    !theme.monologueBottom &&
    css`
      border-top: 0;

      &::after {
        right: 0;
        top: 0;
        width: calc(${spacingScale} + 2);
        border-top: ${monologueTokens.ContainerBorderSizeBaseDefault} solid
          ${monologueTokens.ContainerBorderColorBaseDefault};
        content: '';
        position: absolute;
      }
    `}

  // For elements that have reached both endings,
  // meaning that they have no scroll at all.
  ${({ theme }) =>
    theme.monologueTop &&
    theme.monologueBottom &&
    css`
      border: 0;
    `}
`;

/* @internal */
export const StyledMonologue = styled.div`
  max-height: ${monologueTokens.ContainerHeightMaximumBaseDefault};
  min-height: ${monologueTokens.ContainerHeightMinimumBaseDefault};

  ${MonologueBody} {
    min-height: ${monologueTokens.ContainerHeightMinimumBaseDefault};
  }

  @media print {
    max-height: none;
    min-height: none;
  }

  ${({ theme }) =>
    theme.monologueHeight === 'small' &&
    css`
      max-height: ${monologueTokens.ContainerHeightMaximumSmallDefault};
      min-height: ${monologueTokens.ContainerHeightMinimumSmallDefault};

      ${MonologueBody} {
        min-height: ${monologueTokens.ContainerHeightMinimumSmallDefault};
      }
    `}

  ${({ theme }) =>
    theme.monologueHeight === 'large' &&
    css`
      max-height: ${monologueTokens.ContainerHeightMaximumLargeDefault};
      min-height: ${monologueTokens.ContainerHeightMinimumLargeDefault};

      ${MonologueBody} {
        min-height: ${monologueTokens.ContainerHeightMinimumLargeDefault};
      }
    `}

    ${({ theme }) =>
    theme.monologueHeight === 'full' &&
    css`
      max-height: none;
      min-height: unset;

      & ${MonologueBody} {
        min-height: unset;
      }
    `}
`;
